/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react";
// import _ from "lodash";
// import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
// import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import PartnersTable from "components/dealerInfo/PartnersTable";
import i18n from "i18next";

// const mobileCategoryListVisibleStyle = { visibility: "visible", opacity: "1" };
// const mobileCategoryListInVisibleStyle = { visibility: "hidden", opacity: "0" };
class Partners extends Component {
  state = {
    filteredPartnersData: this.props.partners,
    filterTerm: "",
    error: null,
  };

  componentDidMount() { }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.filterTerm !== prevState.filterTerm && this.props.partners !== null) {
      this.setState({
        filteredPartnersData: this.props.partners.filter((partner) => {
          return partner.dealerPartnerName
            .toLowerCase()
            .includes(this.state.filterTerm.toLowerCase());
        }),
      });
    }
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  renderTableToolbar = () => {
    return (
      <div className="row align-items-center py-3 eduTitleArea">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="row">
            <div className="col-xs-0 col-sm-0 col-md-10 col-lg-10 tableSearchArea"></div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 tableSearchArea">
              <div className="inner-addon right-addon">
                <span className="iconmford fo-icon-search"></span>
                <input
                  type="text"
                  name="tableSearch"
                  id="tableSearch"
                  className="form-control"
                  placeholder={i18n.t("10053")}
                  onChange={(e) => this.handleFilter(e)}
                  value={this.state.filterTerm}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    // if (!this.props.partners)
    //   return null

    return (
      <>
        {this.renderTableToolbar()}

        <div className="row py-4 bottomRow">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <PartnersTable data={this.state.filteredPartnersData} />
          </div>
        </div>
      </>
    );
  }
}

export default Partners;
